export const getPortugalData = () => ({
  name: "Portugal",
  description: "Le Portugal est un pays viticole traditionnel avec une histoire millénaire, produisant des vins uniques à partir de cépages autochtones. Le pays est réputé pour son Porto, ses vins de Madère et ses vins de table de qualité.",
  type: "country",
  regions: [
    { name: "Douro", area: "45,000 ha", percentage: "25%", description: "Porto et vins de table" },
    { name: "Alentejo", area: "22,000 ha", percentage: "12%", description: "Vins rouges puissants" },
    { name: "Vinho Verde", area: "21,000 ha", percentage: "12%", description: "Vins blancs frais" },
    { name: "Dão", area: "20,000 ha", percentage: "11%", description: "Vins de qualité" },
    { name: "Bairrada", area: "12,000 ha", percentage: "7%", description: "Vins traditionnels" },
    { name: "Autres", area: "60,000 ha", percentage: "33%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Douro", x: -7.5, y: 41.2, color: "#4B164C", size: 7 },
    { region: "Alentejo", x: -7.8, y: 38.5, color: "#6d2c7a", size: 6 },
    { region: "Vinho Verde", x: -8.5, y: 41.5, color: "#8a4a8a", size: 5 },
    { region: "Dão", x: -7.8, y: 40.5, color: "#a768a6", size: 5 },
    { region: "Bairrada", x: -8.5, y: 40.5, color: "#c486c4", size: 4 }
  ],
  statistics: {
    totalArea: "180,000 ha",
    production: "6.5 million hectolitres",
    regions: "6 régions principales",
    appellations: "30+ appellations",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influences atlantiques, étés chauds et hivers doux",
    soil: "Sols granitiques, schisteux, calcaires, excellente diversité géologique",
    viticulture: "Tradition millénaire, cépages autochtones, techniques modernes"
  },
  wineStyles: {
    red: "Vins rouges structurés et fruités, avec des tanins mûrs et une excellente complexité",
    white: "Vins blancs secs et aromatiques, avec une fraîcheur et une acidité naturelle",
    rosé: "Rosés fruités et équilibrés, parfaits pour l'apéritif",
    fortified: "Porto et Madère, vins fortifiés de renommée mondiale"
  },
  history: "La viticulture portugaise remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. Le Portugal a une tradition viticole millénaire, avec des cépages autochtones comme le Touriga Nacional. Aujourd'hui, le Portugal est reconnu pour ses vins de qualité et ses vins fortifiés prestigieux.",
  foodPairing: "Cuisine portugaise traditionnelle : bacalhau, sardines, charcuteries, fromages affinés. Les vins portugais s'accordent parfaitement avec la cuisine locale et les plats internationaux."
}); 